/* eslint-disable @typescript-eslint/no-var-requires */
import { LoadingIndicator as Spinner } from 'common/components/common/style';
import { getScalablePixel } from 'common/utils';
import { isRiveSupported } from 'common/utils/helpers';
import React, { useEffect, useMemo, useState } from 'react';
import { LoadingIndicatorContainer } from './LoadingIndicator.styles';
//@ts-ignore
import RiveAnimation from '@assets/animations/loader.riv';
import { useRive as useRiveHook } from '@rive-app/react-canvas';
import variables from 'common/config/variables';

const RIVE_SUPPORTED = isRiveSupported();

let useRive: typeof useRiveHook;
if (RIVE_SUPPORTED) {
  useRive = require('@rive-app/react-canvas').useRive;
}

const RiveLoader = (props: LoadingIndicatorProps) => {
  const [finish, setFinish] = useState(false);
  const [error, setError] = useState(false);
  const { RiveComponent } = useRive({
    src: RiveAnimation,
    stateMachines: 'loading',
    animations: props.state || 'loading',
    autoplay: true,
    onLoadError: () => {
      setError(true);
    },
    onStop: (e: any) => {
      e.data && e.data.toString().includes('done') && setFinish(true);
    }
  });

  useEffect(() => {
    if (finish) {
      props.onFinish && props.onFinish();
    }
  }, [finish, props.onFinish]);

  useEffect(() => {
    if (props.state?.includes('done') && error) {
      setFinish(true);
    }
  }, [props.state]);

  if (!RIVE_SUPPORTED) {
    return null;
  }

  if (error) {
    return <Spinner />;
  }

  return (
    <RiveComponent
      style={{
        width: getScalablePixel(500),
        height: getScalablePixel(500)
      }}
    />
  );
};

export type LoadingState = 'loading' | 'done';
interface LoadingIndicatorProps {
  state?: LoadingState;
  onFinish?: () => void;
}

export default function LoadingIndicator(props: LoadingIndicatorProps) {
  const supported = useMemo(() => !variables.DISABLE_RIVE && RIVE_SUPPORTED, []);

  useEffect(() => {
    if (!supported && props.state?.includes('done') && props.onFinish) {
      props.onFinish();
    }
  }, [props.state, props.onFinish, supported]);

  return (
    <LoadingIndicatorContainer>
      {supported ? <RiveLoader {...props} /> : <Spinner />}
    </LoadingIndicatorContainer>
  );
}
